import { render, staticRenderFns } from "./offerFooter.vue?vue&type=template&id=3bd9813e&scoped=true&"
import script from "./offerFooter.vue?vue&type=script&lang=js&"
export * from "./offerFooter.vue?vue&type=script&lang=js&"
import style0 from "./offerFooter.vue?vue&type=style&index=0&id=3bd9813e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd9813e",
  null
  
)

export default component.exports